import { render } from "./FileName.vue?vue&type=template&id=055980ba&scoped=true"
import script from "./FileName.vue?vue&type=script&lang=js"
export * from "./FileName.vue?vue&type=script&lang=js"

import "./FileName.vue?vue&type=style&index=0&id=055980ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055980ba"]])

export default __exports__